import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';

import { BaseService } from '../../services/base.service';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { JwtHelperService } from "@auth0/angular-jwt";
import { HttpParams } from '@angular/common/http';
import * as moment from 'moment';
const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService extends BaseService {
  updateInterval: number = null;


  isLoggedIn() {
    let _token: string = localStorage.getItem('accessToken')
    const decodedToken = helper.decodeToken(_token);
    const isExpired = helper.isTokenExpired(_token);

    if (_token == null && _token == undefined) {
      return false;
    }


    if (!isExpired && decodedToken.role != 'Retailer') {
      return true
    }

    return false
  }

  isPrimaryUser(): boolean {
    let _token: string = localStorage.getItem('accessToken')
    const decodedToken = helper.decodeToken(_token);
    if (decodedToken.role == "Super Admin" || decodedToken.role == "Admin View" ) {
      return true
    }
    return false
  }

  isUserBillingDpt(): boolean {
    let _token: string = localStorage.getItem('accessToken')
    const decodedToken = helper.decodeToken(_token);
    if (decodedToken.role == "Billing Dept") {
      return true
    }
    return false
  }

  isUserSalesRep(): boolean {
    let _token: string = localStorage.getItem('accessToken')
    const decodedToken = helper.decodeToken(_token);
    if (decodedToken.role == "Sales Rep") {
      return true
    }
    return false
  }



}

